<!-- Change Sales Rep Modal  -->
<p-dialog
  [visible]="clientHistoryModal()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '660px' }"
  styleClass="no-header-modal no-backdrop-overlay"
  (onHide)="closeDialogEvent()"
  aria-label="client-history-dialog"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    @if (
      {
        client: allClientData$ | async,
      };
      as $
    ) {
      <!-- Header -->
      <div
        class="h-3rem md:pl-4 pl-3 pr-5 flex align-items-center relative border-bottom-1 border-300"
      >
        <div class="flex align-items-center">
          <h2 class="mb-0 text-sm">
            {{ 'CLIENT_PROFILE.CLIENT_HISTORY' | translate }}
            <strong>{{ $.client.full_name }}</strong>
            <span class="text-xs text-600"> - {{ $.client.id }}</span>
          </h2>
        </div>
        <div
          class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mr-4 cursor-pointer"
          (click)="closeDialogEvent()"
        ></div>
      </div>
      <!-- Header -->
      <!-- Modal Content -->
      <div class="surface-0 px-3 py-4 md:px-5">
        <app-data-grid
          [columnData]="tableData"
          [columns]="tableColumns"
          [selectable]="false"
          tableClasses="shadow-2 p-0 my-3"
          [headerClasses]="'surface-100 text-xs text-600 white-space-nowrap'"
          [EmptyState]="emptyStateComponent$"
          [paginator]="false"
          [loading]="loading"
          [gridName]="'client-history-list'"
        />
      </div>
      <!-- Modal Content -->
    }
  </ng-template>
</p-dialog>
<!-- Change Sales Rep Modal  -->
